const menu = [
  {
    icon: "dashboard-fill",
    text: "Dashboard",
    link: "/dashboard",
  },
  {
    icon: "bag-fill",
    text: "Orders",
    link: "/orders",
  },
  {
    icon: "cart-fill",
    text: "Abandoned Checkouts",
    link: "/abandoned-checkouts",
  },
  {
    icon: "users-fill",
    text: "Customers",
    link: "/customers",
  },
  {
    icon: "package-fill",
    text: "Products",
    active: false,
    subMenu: [
      {
        text: "Add Product",
        link: "/add-product",
      },
      {
        text: "Products List",
        link: "/product-list",
      },
    ],
  },
  {
    icon: "bag-fill",
    text: "Category List",
    link: "/categories",
  },
  {
    icon: "bag-fill",
    text: "Offer Bar",
    link: "/offer-bar",
  },
  {
    icon: "bag-fill",
    text: "Home Banner",
    link: "/banner",
  },
  {
    icon: "home-fill",
    text: "Homepage Content",
    link: "/homepage-content",
  },
  {
    icon: "file-text-fill",
    text: "Pages",
    link: "/pages",
  },
  {
    icon: "book-fill",
    text: "Journal",
    link: "/journal",
  },
  {
    icon: "bag-fill",
    text: "Social Link",
    link: "/social-link",
  },
   {
    icon: "bag-fill",
    text: "Contact Detail",
    link: "/contact-detail",
  },
  {
    icon: "star-fill",
    text: "Reviews",
    link: "/reviews",
  },
  {
    icon: "chat-circle-fill",
    text: "Enquiries",
    link: "/enquiries",
  },
  {
    icon: "lock-alt-fill",
    text: "Change Password",
    link: "/change-password",
  },
];
export default menu;
